export default __webpack_public_path__ + "static/media/GR00009-user_male.7c58d62e.svg";